import React, { useState } from "react";
import "./SystemConfiguration.css";
import Header from "./ConfigHeader";
import SearchAndFilter from "./SearchAndFilter";
import QueueList from "./QueueList";
import QueueForm from "./QueueForm";
import { useSelector } from "react-redux";
import { searchQueue } from "../../../store/queueSlice";
import { useDispatch } from "react-redux";

const SystemConfiguration = () => {
  const { queueListData } = useSelector((state) => state.queue);
  const dispatch = useDispatch();
  const [showRuleAddSection, setShowRuleAddSection] = useState(false);
  const [queueSearchTerm, setQueueSearchTerm] = useState("");
  const [selectedPriority, setSelectedPriority] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [disableInput, setDisableInput] = useState(false);
  const [currentQueuePage, setCurrentQueuePage] = useState(1);
  const [selectedRules, setSelectedRules] = useState([]);
  const [formData, setFormData] = useState({
    queue_id: "",
    queue_name: "",
    description: "",
    priority: "",
    is_active: true,
    routing_rules: [],
    assignedCoders: [],
  });

  const handleQueueSearch = (e) => {
    const value = e.target.value;
    setQueueSearchTerm(value); // updates local state
    dispatch(searchQueue(value)); // uses the new value directly
  };

  const handleRuleAdder = (e) => {
    e?.preventDefault();
    setShowRuleAddSection((prev) => !prev);
  };

  return (
    <div className="queue-wrapper mt-1">
      <Header
        formData={formData}
        setFormData={setFormData}
        setSelectedPriority={setSelectedPriority}
        setSelectedStatus={setSelectedStatus}
        setCurrentQueuePage={setCurrentQueuePage}
        setQueueSearchTerm={setQueueSearchTerm}
        setDisableInput={setDisableInput}
        selectedRules={selectedRules}
        setSelectedRules={setSelectedRules}
      />
      <SearchAndFilter
        handleQueueSearch={handleQueueSearch}
        queueSearchTerm={queueSearchTerm}
        selectedPriority={selectedPriority}
        setSelectedPriority={setSelectedPriority}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
      />
      <div className="config-wrapper-card-section">
        <QueueList
          queueSearchTerm={queueSearchTerm}
          selectedStatus={selectedStatus}
          selectedPriority={selectedPriority}
          setDisableInput={setDisableInput}
          currentQueuePage={currentQueuePage}
          setCurrentQueuePage={setCurrentQueuePage}
        />
        <div className="right-section-queue">
          <QueueForm
            showRuleAddSection={showRuleAddSection}
            handleRuleAdder={handleRuleAdder}
            formData={formData}
            setFormData={setFormData}
            disableInput={disableInput}
            selectedRules={selectedRules}
            setSelectedRules={setSelectedRules}
          />
        </div>
      </div>
    </div>
  );
};

export default SystemConfiguration;
